"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wholeHoursFromUnixEpoch = exports.wholeUnitsFromUnixEpoch = void 0;
const time_and_date_util_1 = require("./time-and-date-util");
function wholeUnitsFromUnixEpoch(msPerPeriod, target) {
    const epochMs = target || target === 0 ? (new Date(target)).getTime() : Date.now();
    return Math.floor(epochMs / msPerPeriod);
}
exports.wholeUnitsFromUnixEpoch = wholeUnitsFromUnixEpoch;
function wholeHoursFromUnixEpoch(target) {
    return wholeUnitsFromUnixEpoch(time_and_date_util_1.HourMs, target);
}
exports.wholeHoursFromUnixEpoch = wholeHoursFromUnixEpoch;
//# sourceMappingURL=time-rotation-util.js.map